import { useState } from "react";
import { Link } from "react-router";
import { useListContext } from "ra-core";
import { Plus, Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import MobileHeader from "./MobileHeader";

interface MobileListHeaderProps {
  title: string;
  createHref?: string;
  onCreateClick?: () => void;
}

export const MobileListHeader = ({ title, createHref, onCreateClick }: MobileListHeaderProps) => {
  const [isSearching, setIsSearching] = useState(false);
  const [query, setQuery] = useState("");
  const { setFilters, filterValues } = useListContext();

  const handleSearch = (value: string) => {
    setQuery(value);
    setFilters({ ...filterValues, q: value || undefined }, {});
  };

  const closeSearch = () => {
    setIsSearching(false);
    setQuery("");
    setFilters({ ...filterValues, q: undefined }, {});
  };

  const hasCreate = onCreateClick || createHref;

  return (
    <MobileHeader>
      {isSearching ? (
        <>
          <input
            autoFocus
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Поиск..."
            className="flex-1 bg-transparent outline-none text-sm min-w-0"
          />
          <Button variant="ghost" size="icon" onClick={closeSearch} className="shrink-0">
            <X className="h-5 w-5" />
          </Button>
        </>
      ) : (
        <>
          <h1 className="text-lg font-semibold flex-1 truncate">{title}</h1>
          <Button
            variant="ghost"
            size="icon"
            className="shrink-0"
            onClick={() => setIsSearching(true)}
          >
            <Search className="h-5 w-5" />
          </Button>
          {hasCreate && (
            onCreateClick ? (
              <Button
                variant="ghost"
                size="icon"
                className="shrink-0"
                onClick={onCreateClick}
              >
                <Plus className="h-5 w-5" />
              </Button>
            ) : (
              <Button asChild variant="ghost" size="icon" className="shrink-0">
                <Link to={createHref!}>
                  <Plus className="h-5 w-5" />
                </Link>
              </Button>
            )
          )}
        </>
      )}
    </MobileHeader>
  );
};
